import { useEffect } from "react";

type Props = {
  open: boolean;
  title: string;
  message?: string;
  onClose: () => void;
  duration?: number;
};

export function SuccessFeedback({
  open,
  title,
  message,
  onClose,
  duration = 1800,
}: Props) {
  useEffect(() => {
    if (!open) return;
    const timer = window.setTimeout(onClose, duration);
    return () => window.clearTimeout(timer);
  }, [duration, onClose, open]);

  if (!open) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[100] flex items-center justify-center bg-gray-950/20 px-6 backdrop-blur-[1px]">
      <output
        aria-live="polite"
        className="w-full max-w-[320px] rounded-[28px] border border-[#e3e8f0] bg-white px-6 py-7 text-center shadow-2xl shadow-gray-950/15 [animation:feedback-pop_280ms_ease-out_both]"
      >
        <svg
          viewBox="0 0 72 72"
          className="mx-auto h-[72px] w-[72px]"
          aria-hidden="true"
        >
          <circle
            cx="36"
            cy="36"
            r="30"
            fill="none"
            stroke="#4e81ee"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="188"
            className="[animation:feedback-ring_520ms_ease-out_both]"
          />
          <path
            d="M21 37.5 31.5 48 52 27"
            fill="none"
            stroke="#4e81ee"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="48"
            className="[animation:feedback-check_720ms_ease-out_both]"
          />
        </svg>
        <p className="mt-4 text-lg font-extrabold text-gray-900">{title}</p>
        {message && (
          <p className="mt-1.5 text-sm leading-6 text-gray-600">{message}</p>
        )}
      </output>
    </div>
  );
}
